angular.module('mymessages').run(['$templateCache', function($templateCache) {
  'use strict';

  $templateCache.put('/mymessages/views/displayMessageThread.html',
    "<div ng-cloak>\r" +
    "\n" +
    "    <div class=\"panel panel-secondary panel-flush\">\r" +
    "\n" +
    "\r" +
    "\n" +
    "        <div ng-if=\"!loading && !httpError\">\r" +
    "\n" +
    "            <div ng-if=\"messageThread.NumberOfMessages > 0\">\r" +
    "\n" +
    "                <div class=\"panel-heading\">\r" +
    "\n" +
    "                    {{ ::messageThread.Messages[0].MessageHeaderText }}&nbsp;\r" +
    "\n" +
    "                    <span ng-if=\"messageThread.NumberOfMessages > 1\">({{ ::messageThread.NumberOfMessages }})</span>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                <div class=\"row panel-body\">\r" +
    "\n" +
    "                    <div class=\"col-xs-12 col-xs-flush\">\r" +
    "\n" +
    "\r" +
    "\n" +
    "                        <div class=\"row panel-row clickable\"\r" +
    "\n" +
    "                             ng-repeat=\"msg in messageThread.Messages\"\r" +
    "\n" +
    "                             ng-click=\"msg.IsCollapsed = !msg.IsCollapsed\">\r" +
    "\n" +
    "\r" +
    "\n" +
    "                            <div class=\"col-xs-2 col-md-1 col-xs-flush\">\r" +
    "\n" +
    "                                <img class=\"ap-dashboard-message-photo extra-dark-grey-border border-width-md rounded-corner-md\"\r" +
    "\n" +
    "                                     lazy-src=\"{{::thumbnailSrc}}\" endpoint-base='patient'>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                            <div class=\"col-xs-10 col-md-11 col-xs-flush\">\r" +
    "\n" +
    "                                <div>\r" +
    "\n" +
    "                                    <span ng-if=\"msg.FromName !== null\">{{::'From' | translate}}&nbsp;:&nbsp;{{::msg.FromName}}</span>\r" +
    "\n" +
    "                                    <span ap-date-formatter date=\"{{::msg.CreateDateTime}}\" format=\"date-time\" class=\"pull-right\"></span>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                                <div class=\"overflow-ellipsis ng-hide\"\r" +
    "\n" +
    "                                     ng-show=\"msg.IsCollapsed\"\r" +
    "\n" +
    "                                     ng-bind-html=\"msg.MessageBodyTextNoLineBreaks\">\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                                <div>\r" +
    "\n" +
    "                                    <div uib-collapse=\"msg.IsCollapsed\" ng-bind-html=\"msg.MessageBodyText\"></div>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                                <div>\r" +
    "\n" +
    "                                    <a  class=\"clickable\">\r" +
    "\n" +
    "                                        <span ng-show ng-hide=\"!msg.IsCollapsed\">Expand</span>\r" +
    "\n" +
    "                                        <span ng-show ng-hide=\"msg.IsCollapsed\">Collapse</span>\r" +
    "\n" +
    "                                        <i ng-class=\"{'ap-chevron-down-blue' : msg.IsCollapsed, 'ap-chevron-up-blue' : !msg.IsCollapsed}\"></i>\r" +
    "\n" +
    "                                    </a>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                        <form name=\"replyMessageForm\" id=\"reply-message-form\" ng-show ng-hide=\"!allowReply\" ng-submit=\"replyToMessage(replyMessageForm)\" class=\"ap-margin-top-15\" novalidate>\r" +
    "\n" +
    "                            <div class=\"row\">\r" +
    "\n" +
    "                                <div class=\"col-xs-2 col-md-1 col-xs-flush\">\r" +
    "\n" +
    "                                    <img class=\"ap-dashboard-message-photo extra-dark-grey-border border-width-md rounded-corner-md\"\r" +
    "\n" +
    "                                         lazy-src=\"{{::thumbnailSrc}}\" endpoint-base='patient'>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                                <div class=\"col-xs-10 col-md-11 col-xs-flush\">\r" +
    "\n" +
    "                                    <div ng-class=\"{ 'has-error' : (replyMessageForm.MessageBody.$invalid && (replyMessageForm.MessageBody.$dirty || replyMessageForm.isSubmitted))}\">\r" +
    "\n" +
    "                                       <textarea\r" +
    "\n" +
    "                                               class=\"form-control ap-margin-bottom-10\"\r" +
    "\n" +
    "                                               name=\"MessageBody\"\r" +
    "\n" +
    "                                               id=\"message-body\"\r" +
    "\n" +
    "                                               ng-model=\"portalMessage.Message\"\r" +
    "\n" +
    "                                               placeholder=\"Reply here\"\r" +
    "\n" +
    "                                               rows=\"5\"\r" +
    "\n" +
    "                                               ap-required=\"metadata.Fields.Message.IsRequired\"\r" +
    "\n" +
    "                                               ng-disabled=\"replying\">\r" +
    "\n" +
    "                                        </textarea>\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                                    <div>\r" +
    "\n" +
    "                                        <button id=\"send-msg-btn\" type=\"submit\" class=\"btn btn-primary btn-lg pull-right\"\r" +
    "\n" +
    "                                                ng-disabled=\"replying\">\r" +
    "\n" +
    "                                            <span ng-show=\"replying\"><ap-spinner></ap-spinner></span>\r" +
    "\n" +
    "                                            {{::'SEND' | translate}}\r" +
    "\n" +
    "                                        </button>\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </form>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                        <a id=\"display-messages-bottom\"></a>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <div class=\"row\" ng-if=\"messageThread.NumberOfMessages <= 0\">\r" +
    "\n" +
    "                <div class=\"col-xs-12 text-center text-center-vert\">\r" +
    "\n" +
    "                    <span>{{::'No messages found.' | translate}}</span>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "        <div class=\"row\" ng-if=\"loading || httpError\">\r" +
    "\n" +
    "            <div class=\"text-center\" ng-show=\"loading\">\r" +
    "\n" +
    "                <ap-spinner size=\"3\"></ap-spinner>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <uib-alert type=\"danger\" ng-show=\"httpError.unhandled\" ng-cloak>\r" +
    "\n" +
    "                {{::'An error has occurred and messages could not be loaded.' | translate}}\r" +
    "\n" +
    "            </uib-alert>\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <uib-alert type=\"danger\" ng-show=\"httpError.is403\" ng-cloak>\r" +
    "\n" +
    "                {{ ::'You do not have access to view patient Messages.' | translate }}\r" +
    "\n" +
    "            </uib-alert>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>"
  );


  $templateCache.put('/mymessages/views/displayMessages.html',
    "<div ng-cloak>\r" +
    "\n" +
    "    <div class=\"panel panel-secondary panel-flush\">\r" +
    "\n" +
    "            <div class=\"panel-heading\">\r" +
    "\n" +
    "            {{ ::panelHeadingText }}\r" +
    "\n" +
    "            <!-- <span ng-if=\"displayMessages.NumberOfMessages > 1\">({{ displayMessages.NumberOfMessages }})</span> -->\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <span class=\"header-menu pull-right\">\r" +
    "\n" +
    "                <div class=\"dropdown-primary\" uib-dropdown>\r" +
    "\n" +
    "                    <button class=\"btn btn-default flush-right\" type=\"button\" id=\"subtype-filter-btn\" uib-dropdown-toggle>\r" +
    "\n" +
    "                    {{ 'Filter' | translate }}&nbsp;&nbsp;\r" +
    "\n" +
    "                        <span class=\"title-text\">{{ selectedMessageSubTypeName }}</span>\r" +
    "\n" +
    "                        <span class=\"caret\"></span>\r" +
    "\n" +
    "                    </button>\r" +
    "\n" +
    "                    <ul class=\"dropdown-menu dropdown-menu-right\" uib-dropdown-menu role=\"menu\" id=\"messageSubTypeFilter\">\r" +
    "\n" +
    "                        <li class=\"clickable\" role=\"presentation\" ng-repeat=\"messageSubType in messageSubTypes\">\r" +
    "\n" +
    "                            <a id=\"subtype-filter-item-{{messageSubType.Id}}\" role=\"menuitem\" tabindex=\"messageSubType.Index\" ng-click=\"filterMessages(messageSubType.Id)\">{{ ::messageSubType.Name }}</a>\r" +
    "\n" +
    "                        </li>\r" +
    "\n" +
    "                    </ul>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </span>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "        <div class=\"row panel-body\">\r" +
    "\n" +
    "            <div class=\"col-xs-12 col-xs-flush\">\r" +
    "\n" +
    "\r" +
    "\n" +
    "                <div ng-if=\"!loading && !httpError\">\r" +
    "\n" +
    "                    <div id=\"no-messages-found-div\" class=\"text-center text-center-vert\" ng-if=\"displayMessages.NumberOfMessages <= 0\">\r" +
    "\n" +
    "                        <span>{{::'No messages found.' | translate}}</span>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                    <div class=\"row panel-row clickable\"\r" +
    "\n" +
    "                         id=\"message-{{msg.MessageId}}\"\r" +
    "\n" +
    "                         ng-repeat=\"msg in displayMessages.Messages\"\r" +
    "\n" +
    "                         ng-click=\"displayMessageThread(msg)\">\r" +
    "\n" +
    "\r" +
    "\n" +
    "                        <div class=\"col-xs-10 col-xs-flush\">\r" +
    "\n" +
    "                            <img class=\"ap-dashboard-message-photo extra-dark-grey-border border-width-md rounded-corner-md\" ng-if=\"!displaySentMessages\"\r" +
    "\n" +
    "                                 lazy-src=\"{{::thumbnailSrc}}\" endpoint-base='patient'>\r" +
    "\n" +
    "                            <img class=\"ap-dashboard-message-photo extra-dark-grey-border border-width-md rounded-corner-md\" ng-if=\"displaySentMessages\"\r" +
    "\n" +
    "                                 lazy-src=\"{{msg.PersonId | apPatientPortalThumbnailSrc:50:50}}\" endpoint-base='patient'>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                            <div class=\"ap-dashboard-message-text\">\r" +
    "\n" +
    "                                <p ng-if=\"msg.NewMessage === true\" class=\"ap-font-bold ap-dashboard-message-text-row\">\r" +
    "\n" +
    "                                    <span ng-if=\"msg.FromName !== null\">\r" +
    "\n" +
    "                                        {{::'From' | translate}} &nbsp;:&nbsp; {{msg.FromName}}&nbsp;&nbsp;|&nbsp;&nbsp;\r" +
    "\n" +
    "                                    </span>\r" +
    "\n" +
    "                                    {{msg.MessageHeaderText}}\r" +
    "\n" +
    "                                </p>\r" +
    "\n" +
    "                                <p ng-if=\"!msg.NewMessage\" class=\"ap-dashboard-message-text-row\">\r" +
    "\n" +
    "                                    <span ng-if=\"msg.FromName !== null\">\r" +
    "\n" +
    "                                        {{::'From' | translate}} &nbsp;:&nbsp; {{msg.FromName}}&nbsp;&nbsp;|&nbsp;&nbsp;\r" +
    "\n" +
    "                                    </span>\r" +
    "\n" +
    "                                    {{msg.MessageHeaderText}}\r" +
    "\n" +
    "                                </p>\r" +
    "\n" +
    "                                <p class=\"ap-dashboard-message-text-row\" ng-bind-html=\"msg.MessageBodyText\"></p>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                        <div class=\"col-xs-2 col-xs-flush\">\r" +
    "\n" +
    "                            <div class=\"overflow-ellipsis\">\r" +
    "\n" +
    "                                <span class=\"pull-right\" ap-date-formatter date=\"{{msg.CreateDateTime}}\" format=\"date\"></span>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                            <div class=\"overflow-ellipsis\">\r" +
    "\n" +
    "                                <span class=\"pull-right\" ap-date-formatter date=\"{{msg.CreateDateTime}}\" format=\"time\"></span>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                <div class=\"row\" ng-if=\"loading || httpError\">\r" +
    "\n" +
    "                    <div class=\"text-center\" ng-show=\"loading\">\r" +
    "\n" +
    "                        <ap-spinner size=\"3\"></ap-spinner>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                    <uib-alert type=\"danger\" ng-show=\"httpError.unhandled\" ng-cloak>\r" +
    "\n" +
    "                        {{::'An error has occurred and messages could not be loaded.' | translate}}\r" +
    "\n" +
    "                    </uib-alert>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                    <uib-alert type=\"danger\" ng-show=\"httpError.is403\" ng-cloak>\r" +
    "\n" +
    "                        {{ ::'You do not have access to view patient Messages.' | translate }}\r" +
    "\n" +
    "                    </uib-alert>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>"
  );


  $templateCache.put('/mymessages/views/myMessages.html',
    "<div ng-cloak>\r" +
    "\n" +
    "    <div class=\"panel panel-primary\">\r" +
    "\n" +
    "        <div ng-if=\"!loading && !httpError\" class=\"panel-body panel-flush\">\r" +
    "\n" +
    "            <div class=\"panel-subheading-messages\">\r" +
    "\n" +
    "                <span ng-if=\"model.subMessageText\">{{model.subMessageText}}</span>\r" +
    "\n" +
    "                <span ng-if=\"!model.subMessageText\">{{::'If this is an emergency, call 911. Messages are for non-urgent correspondence.' | translate}}</span>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <div class=\"col-xs-3 col-md-2 col-xs-flush\">\r" +
    "\n" +
    "                <div class=\"ap-mymessages-nav\">\r" +
    "\n" +
    "                    <ul class=\"list-unstyled\">\r" +
    "\n" +
    "                        <li>\r" +
    "\n" +
    "                            <button id=\"messages-new-message-btn\" class=\"btn btn-default1\"\r" +
    "\n" +
    "                                    data-transition-to=\"{appRoute: 'myMessagesNewMessage'}\">{{::'Compose New' | translate }}\r" +
    "\n" +
    "                            </button>\r" +
    "\n" +
    "                        </li>\r" +
    "\n" +
    "                    </ul>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                    <div class=\"ap-mymessages-nav-divider\"></div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                    <uib-tabset class=\"list-unstyled\" vertical=\"true\" uib-collapse=\"false\">\r" +
    "\n" +
    "                        <uib-tab id=\"messages-inbox-btn\" ng-click=\"messageLinkSelected('messages-inbox-btn')\"\r" +
    "\n" +
    "                             data-transition-to=\"{appRoute: 'myMessagesDisplayMessages', opts: {displayMode: 'received'}}\">\r" +
    "\n" +
    "                            <uib-tab-heading>\r" +
    "\n" +
    "                                {{::'Inbox' | translate }}\r" +
    "\n" +
    "                            </uib-tab-heading>\r" +
    "\n" +
    "                        </uib-tab>\r" +
    "\n" +
    "                        <uib-tab id=\"messages-sent-btn\" ng-click=\"messageLinkSelected('messages-sent-btn')\"\r" +
    "\n" +
    "                             data-transition-to=\"{appRoute: 'myMessagesDisplayMessages', opts: {displayMode: 'send'}}\">\r" +
    "\n" +
    "                            <uib-tab-heading>\r" +
    "\n" +
    "                                {{::'Sent' | translate }}\r" +
    "\n" +
    "                            </uib-tab-heading>\r" +
    "\n" +
    "                        </uib-tab>\r" +
    "\n" +
    "                    </uib-tabset>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <div class=\"col-xs-9 col-md-10 col-xs-flush\">\r" +
    "\n" +
    "                <div class=\"container-fluid container-flush\" ui-view></div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "        <div ng-if=\"loading || httpError\">\r" +
    "\n" +
    "            <div class=\"text-center\" ng-show=\"loading\">\r" +
    "\n" +
    "                <ap-spinner size=\"3\"></ap-spinner>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <uib-alert type=\"danger\" ng-show=\"httpError.unhandled\" ng-cloak>\r" +
    "\n" +
    "                {{::'An error has occurred and the patient messages could not be loaded.' | translate}}\r" +
    "\n" +
    "            </uib-alert>\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <uib-alert type=\"danger\" ng-show=\"httpError.is403\" ng-cloak>\r" +
    "\n" +
    "                {{ ::'You do not have access to view patient Messages.' | translate }}\r" +
    "\n" +
    "            </uib-alert>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>"
  );


  $templateCache.put('/mymessages/views/myMessagesMobile.html',
    "<div class=\"container-fluid container-flush hidden-print\" ng-cloak>\r" +
    "\n" +
    "    <div class=\"panel panel-mobile\" ng-if=\"!httpError\">\r" +
    "\n" +
    "        <div class=\"panel-header\">\r" +
    "\n" +
    "            <div class=\"panel-title text-uppercase\">\r" +
    "\n" +
    "                <img class=\"toolbar-svg messages\" src=\"images/spacer.png\">\r" +
    "\n" +
    "                <span class=\"title-text\">{{::\"Messages\" | translate }}</span>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "            <div class=\"panel-notice\" ng-if=\"!isInSubstate()\">\r" +
    "\n" +
    "                <h6 class=\"text-uppercase\" ng-if=\"!mobileModel.subMessageText\">\r" +
    "\n" +
    "                    <b>\r" +
    "\n" +
    "                        {{::\"If this is an emergency, call 911.\" | translate }}\r" +
    "\n" +
    "                    </b>\r" +
    "\n" +
    "                    <BR>\r" +
    "\n" +
    "                    {{::\"Messages are for non-urgent correspondence.\" | translate }}\r" +
    "\n" +
    "                </h6>\r" +
    "\n" +
    "                <h6 class=\"text-uppercase\" ng-if=\"mobileModel.subMessageText\">\r" +
    "\n" +
    "                    <b>{{mobileModel.subMessageText}}</b>\r" +
    "\n" +
    "                </h6>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "            <div class=\"row\" ng-if=\"isInSubstate()\">\r" +
    "\n" +
    "                <div class=\"col-xs-6 col-xs-flush mobile-back-header\">\r" +
    "\n" +
    "                    <button class=\"btn btn-icon\" type=\"button\" id=\"messages-back\" ng-click=\"goBackToMessages();\">\r" +
    "\n" +
    "                        <span><i class=\"fa fa-caret-left\" /></span>\r" +
    "\n" +
    "                        <span>{{:: \"Back\" | translate}}</span>\r" +
    "\n" +
    "                    </button>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "        <div class=\"panel-body col-xs-12 col-xs-flush\" ng-if=\"isInSubstate()\" ui-view>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "        <div class=\"panel-body col-xs-12 col-xs-flush\" ng-if=\"!isInSubstate()\" ng-init=\"changeFolder();\">\r" +
    "\n" +
    "            <div class=\"container-fluid container-flush\" ng-cloak>\r" +
    "\n" +
    "                <div class=\"row\" ng-cloak>\r" +
    "\n" +
    "                    <div class=\"col-xs-12 col-xs-flush\">\r" +
    "\n" +
    "                        <div id=\"my-messages-panel\" class=\"panel panel-tile-secondary panel-flush\">\r" +
    "\n" +
    "                            <div class=\"panel-heading\">\r" +
    "\n" +
    "                                <div class=\"icon-group text-center-vert pull-right\">\r" +
    "\n" +
    "                                    <span class=\"clickable\">\r" +
    "\n" +
    "                                <span class=\"header-menu\">\r" +
    "\n" +
    "                                    <span class=\"dropdown-primary\" uib-dropdown>\r" +
    "\n" +
    "                                        <button class=\"btn btn-default btn-icon btn-nowrap\" type=\"button\" id=\"message-filter-btn\" uib-dropdown-toggle>\r" +
    "\n" +
    "                                            <i class=\"fa fa-filter\" />\r" +
    "\n" +
    "                                            <span class=\"caret\"></span>\r" +
    "\n" +
    "                                        </button>\r" +
    "\n" +
    "                                        <ul class=\"dropdown-menu dropdown-menu-right\" uib-dropdown-menu role=\"menu\" id=\"messageSubTypeFilter\">\r" +
    "\n" +
    "                                            <li class=\"clickable\" role=\"presentation\" ng-repeat=\"messageSubType in messageSubTypes\">\r" +
    "\n" +
    "                                                <a id=\"message-filter-item-{{messageSubType.Id}}\" role=\"menuitem\"\r" +
    "\n" +
    "                                                   ng-click=\"filterMessages(messageSubType.Id)\">\r" +
    "\n" +
    "                                                    <span>\r" +
    "\n" +
    "                                                        <i class=\"fa fa-filter\" ng-if=\"selectedMessageSubTypeName == messageSubType.Name\" />\r" +
    "\n" +
    "                                                        &nbsp;{{::messageSubType.Name | translate}}\r" +
    "\n" +
    "                                                    </span>\r" +
    "\n" +
    "                                                </a>\r" +
    "\n" +
    "                                            </li>\r" +
    "\n" +
    "                                        </ul>\r" +
    "\n" +
    "                                    </span>\r" +
    "\n" +
    "                                </span>\r" +
    "\n" +
    "                                    </span>\r" +
    "\n" +
    "                                    <span class=\"clickable\"\r" +
    "\n" +
    "                                         ng-click=\"composeNewMessage();\">\r" +
    "\n" +
    "                                        <i class=\"fa fa-pencil\"></i>\r" +
    "\n" +
    "                                    </span>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                                <div class=\"clickable\">\r" +
    "\n" +
    "                                    <div class=\"icon-group pull-right ng-hide\" ng-show=\"loading\">\r" +
    "\n" +
    "                                        <ap-spinner></ap-spinner>\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "                                    <div class=\"folder-dropdown\" uib-dropdown>\r" +
    "\n" +
    "                                        <button class=\"btn btn-header btn-nopadding\" type=\"button\" id=\"message-folders-context-menu\" uib-dropdown-toggle>\r" +
    "\n" +
    "                                            <span class=\"panel-title\">{{selectedFolder.Name | translate}}</span>\r" +
    "\n" +
    "                                            <span class=\"caret\"></span>\r" +
    "\n" +
    "                                        </button>\r" +
    "\n" +
    "                                        <ul class=\"dropdown-menu dropdown-menu-right\" uib-dropdown-menu role=\"menu\" aria-labelledby=\"message-folders-context-menu\">\r" +
    "\n" +
    "                                            <li role=\"presentation\" ng-repeat=\"folder in folders track by folder.Key\">\r" +
    "\n" +
    "                                                <a id=\"message-folder-{{::folder.Key}}\" role=\"menuitem\" tabindex=\"{{::$index}}\" data-transition-to=\"{appRoute: 'myMessagesMobile', opts: { folder: folder.Key }}\">{{::folder.Name | translate}}</a>\r" +
    "\n" +
    "                                            </li>\r" +
    "\n" +
    "                                        </ul>\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                            <ul class=\"list-group list-group-fixed-height\" ng-show=\"!loading && !displayMessages.Messages.length\">\r" +
    "\n" +
    "                                <li class=\"list-group-item\">\r" +
    "\n" +
    "                                    <div class=\"col-xs-12 text-center-vert text-center\">\r" +
    "\n" +
    "                                        <span>{{::'No messages found.' | translate}}</span>\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "                                </li>\r" +
    "\n" +
    "                            </ul>\r" +
    "\n" +
    "                            <ul class=\"list-group list-group-fixed-height\" ng-show=\"!loading && displayMessages.Messages.length\">\r" +
    "\n" +
    "                                <li ng-repeat=\"message in displayMessages.Messages track by $index\" class=\"list-group-item\" ng-click=\"displayMessageThreadMobile(message)\">\r" +
    "\n" +
    "                                    <div class=\"list-item-col-xs list-item-sub-heading overflow-ellipsis text-center-vert pull-right\">\r" +
    "\n" +
    "                                        <div class=\"text-center-vert pull-right\">\r" +
    "\n" +
    "                                            <span class=\"clickable\"><i class=\"fa fa-caret-right\"></i></span>\r" +
    "\n" +
    "                                        </div>\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "                                    <div class=\"list-item\" ng-class=\"{'ap-message-unread': message.NewMessage }\">\r" +
    "\n" +
    "                                        <div class=\"list-item-details ap-message-sender overflow-ellipsis\">\r" +
    "\n" +
    "                                            {{::message.FromName}}\r" +
    "\n" +
    "                                        </div>\r" +
    "\n" +
    "                                        <div class=\"list-item-details overflow-ellipsis\">\r" +
    "\n" +
    "                                            {{::message.MessageHeaderText}}\r" +
    "\n" +
    "                                        </div>\r" +
    "\n" +
    "                                        <div class=\"list-item-heading-small overflow-ellipsis\">\r" +
    "\n" +
    "                                            {{::message.MessageBodyText}}\r" +
    "\n" +
    "                                        </div>\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "                                </li>\r" +
    "\n" +
    "                            </ul>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "    <div ng-if=\"httpError\">\r" +
    "\n" +
    "        <uib-alert type=\"danger\" ng-show=\"httpError.unhandled\" ng-cloak>\r" +
    "\n" +
    "            {{ ::'An error has occurred and Messages could not be loaded.' | translate }}\r" +
    "\n" +
    "        </uib-alert>\r" +
    "\n" +
    "        <uib-alert type=\"danger\" ng-show=\"httpError.is403\" ng-cloak translate>\r" +
    "\n" +
    "            {{ ::'You do not have access to Messages.' | translate }}\r" +
    "\n" +
    "        </uib-alert>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>\r" +
    "\n"
  );


  $templateCache.put('/mymessages/views/newMessage.html',
    "<div ng-cloak>\r" +
    "\n" +
    "    <div class=\"panel panel-secondary panel-flush\">\r" +
    "\n" +
    "\r" +
    "\n" +
    "        <div ng-if=\"!loading && !httpError\">\r" +
    "\n" +
    "            <div class=\"panel-heading\">\r" +
    "\n" +
    "                {{ ::'Compose New Message' | translate }}\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <div class=\"panel-body\">\r" +
    "\n" +
    "                <form name=\"portalMessageForm\" novalidate>\r" +
    "\n" +
    "                    <div class=\"col-xs-12 col-xs-flush\">\r" +
    "\n" +
    "                        <div class=\"form-group ap-margin-top-15\"\r" +
    "\n" +
    "                             ng-class=\"{ 'has-error' : (portalMessageForm.ProviderOrServiceSite.$invalid && (portalMessageForm.ProviderOrServiceSite.$dirty || portalMessageForm.isSubmitted))}\">\r" +
    "\n" +
    "                            <label class=\"control-label\">{{::routeTypeString}}</label>\r" +
    "\n" +
    "                                <select class=\"form-control arrow-dropdown\"\r" +
    "\n" +
    "                                        name=\"ProviderOrServiceSite\"\r" +
    "\n" +
    "                                        id=\"provider-or-servicesite-select\"\r" +
    "\n" +
    "                                        ng-change=\"selectedProviderOrServiceSiteChanged()\"\r" +
    "\n" +
    "                                        ng-model=\"portalMessage.ProviderOrServiceSiteId\"\r" +
    "\n" +
    "                                        ng-options=\"messageSetting.ProviderOrServiceSiteId as messageSetting.Name for messageSetting in messageSettings\"\r" +
    "\n" +
    "                                        ap-required=\"true\"\r" +
    "\n" +
    "                                        ng-disabled=\"sending\">\r" +
    "\n" +
    "                                </select>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                    <div class=\"col-xs-12 col-xs-flush\">\r" +
    "\n" +
    "                        <div class=\"form-group\"\r" +
    "\n" +
    "                             ng-class=\"{ 'has-error' : (portalMessageForm.MessageSubType.$invalid && (portalMessageForm.MessageSubType.$dirty || portalMessageForm.isSubmitted))}\">\r" +
    "\n" +
    "                            <label class=\"control-label\">{{'Message Type' | translate}}</label>\r" +
    "\n" +
    "                                <select class=\"form-control arrow-dropdown\"\r" +
    "\n" +
    "                                        name=\"MessageSubType\"\r" +
    "\n" +
    "                                        id=\"message-sub-type-select\"\r" +
    "\n" +
    "                                        ng-model=\"portalMessage.SubTypeId\"\r" +
    "\n" +
    "                                        ng-options=\"messageSubType.Id as messageSubType.Name for messageSubType in messageSubTypes\"\r" +
    "\n" +
    "                                        ap-required=\"true\"\r" +
    "\n" +
    "                                        ng-disabled=\"sending\">\r" +
    "\n" +
    "                                </select>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                    <div class=\"col-xs-12 col-xs-flush\">\r" +
    "\n" +
    "                        <div class=\"form-group\"\r" +
    "\n" +
    "                             ng-class=\"{ 'has-error' : (portalMessageForm.Header.$invalid && (portalMessageForm.Header.$dirty || portalMessageForm.isSubmitted))}\">\r" +
    "\n" +
    "                            <label class=\"control-label\">{{::'Subject'| translate}}</label>\r" +
    "\n" +
    "                            <input type=\"text\"\r" +
    "\n" +
    "                                   class=\"form-control\"\r" +
    "\n" +
    "                                   name=\"Header\"\r" +
    "\n" +
    "                                   id=\"message-header\"\r" +
    "\n" +
    "                                   ng-model=\"portalMessage.Header\"\r" +
    "\n" +
    "                                   ap-required=\"metadata.Fields.Header.IsRequired\"\r" +
    "\n" +
    "                                   ng-disabled=\"sending\" />\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                    <div ng-if=\"portalMessage.SubTypeId == patientAttachmentSubtype \">\r" +
    "\n" +
    "                        <div class=\"form-group\">\r" +
    "\n" +
    "                        <label class=\"control-label\">{{::'Upload an Attachment' | translate}}</label>\r" +
    "\n" +
    "                           <ap-message-attachment\r" +
    "\n" +
    "                                attachment-dto-list = \"AttachmentList.attachmentDtoList\">\r" +
    "\n" +
    "                        </ap-message-attachment>\r" +
    "\n" +
    "                       </div>\r" +
    "\n" +
    "                        <div class=\"row text-danger\"  ng-if=\"AttachmentList.validationMessage.length > 0 && AttachmentList.attachmentDtoList.length === 0\">\r" +
    "\n" +
    "                            <div class=\"col-xs-12\" id=\"divValidationMessage\" name=\"divValidationMessage\">\r" +
    "\n" +
    "                                {{ AttachmentList.validationMessage }}\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                    <div class=\"col-xs-12 col-xs-flush\">\r" +
    "\n" +
    "                        <div class=\"form-group ap-margin-bottom-10\"\r" +
    "\n" +
    "                             ng-class=\"{ 'has-error' : (portalMessageForm.MessageBody.$invalid && (portalMessageForm.MessageBody.$dirty || portalMessageForm.isSubmitted))}\">\r" +
    "\n" +
    "                            <label class=\"control-label\">{{'Message' | translate}}</label>\r" +
    "\n" +
    "                            <textarea\r" +
    "\n" +
    "                                   class=\"form-control\"\r" +
    "\n" +
    "                                   name=\"MessageBody\"\r" +
    "\n" +
    "                                   id=\"message-body\"\r" +
    "\n" +
    "                                   ng-model=\"portalMessage.Message\"\r" +
    "\n" +
    "                                   placeholder=\"Message here\"\r" +
    "\n" +
    "                                   rows=\"5\"\r" +
    "\n" +
    "                                   ap-required=\"metadata.Fields.Message.IsRequired\"\r" +
    "\n" +
    "                                   ng-disabled=\"sending\">\r" +
    "\n" +
    "                            </textarea>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                    <div class=\"col-xs-6 col-xs-flush-left\">\r" +
    "\n" +
    "                        <button id=\"cancel-msg-btn\" class=\"btn btn-default2 btn-lg pull-left\" ng-disabled=\"sending\"\r" +
    "\n" +
    "                                data-transition-to=\"{appRoute: returnRoute, opts: returnOpts }\">\r" +
    "\n" +
    "                            {{::'CANCEL' | translate}}\r" +
    "\n" +
    "                        </button>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                    <div class=\"col-xs-6 col-xs-flush-right\">\r" +
    "\n" +
    "                        <button id=\"send-msg-btn\" class=\"btn btn-primary btn-lg pull-right\" ng-disabled=\"sending\"\r" +
    "\n" +
    "                                ng-click=\"sendMessage(portalMessageForm)\">\r" +
    "\n" +
    "                            <span ng-show=\"sending\"><ap-spinner></ap-spinner></span>\r" +
    "\n" +
    "                            {{::'SEND' | translate}}\r" +
    "\n" +
    "                        </button>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                </form>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "        <div ng-if=\"loading || httpError\">\r" +
    "\n" +
    "            <div class=\"text-center\" ng-show=\"loading\">\r" +
    "\n" +
    "                <ap-spinner size=\"3\"></ap-spinner>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <uib-alert type=\"danger\" ng-show=\"httpError.unhandled\" ng-cloak>\r" +
    "\n" +
    "                {{::'An error has occurred and messages could not be loaded.' | translate}}\r" +
    "\n" +
    "            </uib-alert>\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <uib-alert type=\"danger\" ng-show=\"httpError.is403\" ng-cloak>\r" +
    "\n" +
    "                {{ ::'You do not have access to view patient Messages.' | translate }}\r" +
    "\n" +
    "            </uib-alert>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>"
  );

}]);
